import { render, staticRenderFns } from "./b-user.vue?vue&type=template&id=1b950a84&scoped=true&"
import script from "./b-user.vue?vue&type=script&lang=js&"
export * from "./b-user.vue?vue&type=script&lang=js&"
import style0 from "./b-user.vue?vue&type=style&index=0&id=1b950a84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b950a84",
  null
  
)

export default component.exports